import React from 'react'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Skeleton from '@mui/material/Skeleton'

import { Paragraph } from 'components/shared'
import BreadcrumbsIcon, { BreadcrumbsItemType } from './BreadcrumbsIcon'
import { useStyles } from './Breadcrumbs.style'
import { Link } from '@centra/centra-ui'

export interface IBreadcrumbsItem {
  title?: string
  link: string
  type?: BreadcrumbsItemType
}

interface IBreadcrumbs {
  breadcrumbs: IBreadcrumbsItem[]
}

const BreadcrumbItem = (props: IBreadcrumbsItem) => {
  const { title, type } = props
  const classes = useStyles()
  if (title) {
    return (
      <Paragraph size={'sm'} className={classes.link}>
        <BreadcrumbsIcon type={type} />
        {title}
      </Paragraph>
    )
  }
  return (
    <Paragraph size={'sm'} className={classes.link}>
      <Skeleton variant="rectangular" width={140} height={18} component={'span'} />
    </Paragraph>
  )
}

const CustomBreadcrumbs = (props: IBreadcrumbs) => {
  const { breadcrumbs } = props
  const classes = useStyles()

  if (!breadcrumbs.length) {
    return <Skeleton variant="text" width={140} height={16} />
  }

  return (
    <Breadcrumbs
      classes={{
        root: classes.root,
        separator: classes.separator,
        li: classes.li,
      }}
      separator={
        <svg width="16px" height="16px">
          <use xlinkHref="#arrow-right" />
        </svg>
      }
    >
      {breadcrumbs.map(({ title, link, type }: IBreadcrumbsItem, index) =>
        breadcrumbs.length - 1 === index ? (
          <BreadcrumbItem key={link} type={type} title={title} link={link} />
        ) : (
          <Link id={link} key={link} href={link}>
            <BreadcrumbItem type={type} title={title} link={link} />
          </Link>
        )
      )}
    </Breadcrumbs>
  )
}

export default CustomBreadcrumbs
